import httpRequest from './httpRequest'

const api = '/loopback/api/SandboxPublics'
const prefix = api
const routeVerdict = prefix + '/verdict'

export default {
  fetchVerdict (sha1Checksum) {
    var url = routeVerdict + '/' + sha1Checksum
    return httpRequest.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/apiSandboxPublic.js